import { ThemeLayout } from '../../front/lib/ThemeLayout';
import { createApp } from 'vue';
import ListArticlesFilters from './ListArticlesFilters.vue';
export class ListArticles extends ThemeLayout {
    init() {
        const filtersAppEl = this.getElementById('filtersApp');
        if (filtersAppEl) {
            this.initFiltersApp(filtersAppEl);
        }
    }
    initFiltersApp(rootEl) {
        const app = createApp(ListArticlesFilters, { mod: this });
        app.mount(rootEl);
    }
}
